import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6} style={{marginTop: "2rem"}}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/arnab-das-17798b145/"
                target="_blank"
              >
                <img src={navIcon1} alt="Icon" />
              </a>
              <a href="https://github.com/arnabdasrishi" target="_blank">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/733/733553.png"
                  alt=""
                />
              </a>
              <a href="#">
                <img src={navIcon2} alt="Icon" />
              </a>
              <a
                href="https://www.instagram.com/arnabdasrishi/"
                target="_blank"
              >
                <img src={navIcon3} alt="Icon" />
              </a>
            </div>
            <div>
              <p>arnabdasrishi@gmail.com</p>
              <p>Phone No: +91 760-2851-400</p>
              <p> © Copyright 2022. All Rights Reserved to Arnab Das</p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
